import { request } from '@/shared/api/request'

export const getSendEmployer = ({ params: { listId } }) =>
	request({ url: `contract/sl/${listId}/allEmployer`, method: 'GET' })
